module.exports = function toNumber(num, precision) {
  if (num == null) return 0;
  var factor = Math.pow(10, isFinite(precision) ? precision : 0);
  return Math.round(num * factor) / factor;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/toNumber.js
 ** module id = 1111
 ** module chunks = 0
 **/